import axios from 'axios'

export default {
    initialize: function () {
        window.ptId = getPtId()
        window.clientId = parseInt(getParamValue('client_id'))
        window.openedByApp = getParamValue('app')
        window.openedByDashboard = getParamValue('dashboard')
        window.apiDev = getParamValue('dev')
        window.diary = getParamValue('diary')
        window.train = getParamValue('train')
        window.trainId = getParamValue('train_id')
        window.filterKey = getParamValue('filter_key')
        window.disablePackForm = getParamValue('disable_pack_form')
        window.trainName = getParamValue('train_name') ? decodeURIComponent(getParamValue('train_name')) : null
        window.trainingPlanId = getParamValue('training_plan_id')
        window.initialQuiz = getParamValue('initial_quiz')
        window.configType = window.diary ? 6 : getConfigType()
        window.language = getLanguage()
        window.datepickerLanguage = getDatepickerLanguage()
        window.screenBackgroundColor = getParamValue('screen_background')
        window.screenBackgroundColor = window.screenBackgroundColor ? window.screenBackgroundColor : getParamValue('background')
        window.getDataCallback = getParamValue('get_data_callback')
        window.physicalEvaluationToEdit = getParamValue('phy_eval_id')
        window.apiKey = getApiKey()
        window.webviewConfig = getWebviewConfig()
        setIndexProperties()
        checkBackground()

        if (window.initialQuiz) {
            window.configType = 99
        }

        if (window.openedByApp == 'true') {
            window.openedByApp = true
        } else {
            window.openedByApp = false
        }

        function getParamValue(param) {
            const queryString = window.location.search
            const urlParams = new URLSearchParams(queryString)
            return urlParams.get(param)
        }

        function getPtId() {
            const ptId = getParamValue('pt_id')
            const pt = getParamValue('pt')
            if (ptId) {
                return parseInt(ptId)
            }
            if (pt) {
                if (window.PTS_IDS && window.PTS_IDS[pt]) {
                    return window.PTS_IDS[pt]
                } else {
                    return pt
                }
            }
            if (window.PTS_TAGS) {
                const ptTag = window.PTS_TAGS.find(function (tag) {
                    return window.location.href.indexOf(tag.key) > -1
                })
                if (ptTag) {
                    return ptTag.id
                }
            }
            return ptId
        }

        function getConfigType() {
            const typeParam = getParamValue('type')
            if (typeParam) {
                return typeParam
            }
            const types = {
                return: 4,
                newplans: 5
            }
            if (window.location.href.indexOf('-return') > -1) {
                return types.return
            }
            if (window.location.href.indexOf('-newplans') > -1) {
                return types.newplans
            }
        }

        function getLanguage() {
            const lng = getParamValue('lng')
            if (lng) {
                return lng
            }
            return 'pt'
        }

        function getDatepickerLanguage() {
            if (window.language === 'en') {
                return 'en-EN'
            }
            if (window.language === 'es') {
                return 'es-ES'
            }
            if (window.language === 'fr') {
                return 'fr-FR'
            }
            return 'pt-PT'
        }

        function getApiKey() {
            if (window.PTS_TAGS) {
                const ptTag = window.PTS_TAGS.find(function (tag) {
                    return window.location.href.indexOf(tag.key) > -1 || tag.id === window.ptId
                })
                if (ptTag && ptTag.api) {
                    return ptTag.api
                }
            }
            return 'common'
        }

        function getWebviewConfig() {
            if (window.PTS_TAGS) {
                const ptTag = window.PTS_TAGS.find(function (tag) {
                    return window.location.href.indexOf(tag.key) > -1
                })
                if (ptTag && ptTag.webview) {
                    return ptTag.webview
                }
            }
            return null
        }

        function setIndexProperties() {
            if (window.webviewConfig) {
                if (window.webviewConfig.title) {
                    document.title = window.webviewConfig.title
                }
                if (window.webviewConfig.icon) {
                    document.querySelector("link[rel='shortcut icon']").href = window.webviewConfig.icon
                }
            }
        }

        function checkBackground() {
            if (window.screenBackgroundColor) {
                if (document.documentElement && document.documentElement.style) {
                    document.documentElement.style.backgroundColor = '#' + window.screenBackgroundColor
                }
                if (document.body && document.body.style) {
                    document.body.style.backgroundColor = '#' + window.screenBackgroundColor
                }
            }
        }
    },
    refreshEnums: function (enums) {
        try {
            if (window.strings) {
                for (const key in enums) {
                    if (enums[key]) {
                        for (let i = 0; i < enums[key].length; i++) {
                            if (enums[key][i].label) {
                                enums[key][i].label = window.strings[enums[key][i].label] ? window.strings[enums[key][i].label] : enums[key][i].label
                            }
                        }
                    }
                }
            }
        } catch (error) { }
        window.enums = enums
    },
    processResponse: function (response, callback, extraData) {
        const self = this
        try {
            const responseData = response && response.request && response.request.response ? JSON.parse(response.request.response) : {
                success: false,
                data: null,
                message: self.getMessageError(response),
            }

            callback({
                success: responseData ? responseData.success : false,
                data: responseData ? responseData.data : null,
                extraData: extraData ? extraData : null,
                message: responseData ? responseData.message : null,
            })
        } catch (error) {
            callback({
                success: false,
                message: self.getMessageError(),
            })
        }
    },
    getMessageError: function (response) {
        let messageError = window.strings && window.strings['server_connection_failed'] ? window.strings['server_connection_failed'] : 'Parece que estamos a enfrentar alguns problemas ao estabelecer ligação com o servidor. Por favor, verifica a ligação à internet ou aguarda um pouco antes de tentar novamente.'

        if (response && response.message && response.message !== 'Network Error' && response.code !== 'ECONNABORTED') {
            messageError = response.message
        }

        return messageError
    },
    getAlertOptions: function (args) {
        const str = window.strings ? window.strings : {
            'ok': 'Ok',
            'cancel': 'Cancelar'
        }
        const obj = {
            confirmButtonText: str['ok'],
            cancelButtonText: str['cancel']
        }
        if (args && args.confirmButtonText) {
            obj.confirmButtonText = args.confirmButtonText
        }
        if (args && args.cancelButtonText) {
            obj.cancelButtonText = args.cancelButtonText
        }
        if (args && args.confirmButtonColor === 'warning') {
            obj.confirmButtonColor = '#fb8c00'
        }
        if (args && args.confirmButtonColor === 'success') {
            obj.confirmButtonColor = '#4caf50'
        }
        if (args && args.cancelButtonColor === 'warning') {
            obj.cancelButtonColor = '#fb8c00'
        }
        if (args && args.cancelButtonColor === 'success') {
            obj.cancelButtonColor = '#4caf50'
        }
        return obj
    },
    getLabel: function (items, value) {
        for (let i = 0; i < items.length; i++) {
            if (items[i].value === value) {
                return items[i].label
            }
        }
    },
    getGenders: function () {
        const enums = window.enums
        if (enums) {
            return enums.genders
        } else {
            return []
        }
    },
    getPhysicalConditions: function () {
        const enums = window.enums
        if (enums) {
            return enums.physical_condition
        } else {
            return []
        }
    },
    getGoals: function () {
        const enums = window.enums
        if (enums) {
            return enums.goals
        } else {
            return []
        }
    },
    getDailyWeightDays: function () {
        const enums = window.enums
        if (enums) {
            return enums.daily_weight_days
        } else {
            return []
        }
    },
    getFeedbackRating: function () {
        const enums = window.enums
        if (enums) {
            return enums.feedback_rating
        } else {
            return []
        }
    },
    getWorkoutFlags: function () {
        const enums = window.enums
        if (enums) {
            return enums.workout_flags
        } else {
            return []
        }
    },
    getFoodIntolerance: function () {
        const enums = window.enums
        if (enums) {
            return enums.food_intolerance
        } else {
            return []
        }
    },
    getCardioOptions: function () {
        const enums = window.enums
        if (enums) {
            return enums.cardio_options
        } else {
            return []
        }
    },
    encodeEmail: function (email) {
        return email.toLowerCase().replace(/ /g, '')
    },
    getFormatDate: function (date) {
        let d = new Date()

        if (date) {
            d = date
        }

        let month = '' + (d.getMonth() + 1)
        let day = '' + d.getDate()
        const year = d.getFullYear()

        if (month.length < 2) {
            month = '0' + month
        }
        if (day.length < 2) {
            day = '0' + day
        }

        return [year, month, day].join('-')
    },
    getDefaultBirthDate: function () {
        let date = new Date()
        date.setFullYear(date.getFullYear() - 18)
        return this.getFormatDate(date)
    },
    refreshAppUrl: function (config) {
        if ((config && config.dev) || window.apiDev) {
            axios.defaults.ptApiUrl = axios.defaults.urls.dev[window.apiKey].base
            axios.defaults.storageApiUrl = axios.defaults.urls.dev[window.apiKey].storage
        }
    },
    setConfigStrings: function (config) {
        if (config.translate) {
            const keys = [
                'title',
                'emptyFailedMessage',
                'subtitle',
                'legend',
                'label',
                'failedMessage',
                'termsFailedMessage',
                'message',
                'info',
                'text',
                'name',
                'parent'
            ]
            handleJson(config)

            function handleJson(src) {
                for (const key in src) {
                    if (keys.indexOf(key) > -1) {
                        src[key + 'TranslationId'] = src[key]
                        src[key] = window.strings[src[key]] ? window.strings[src[key]] : src[key]
                    }
                    if (typeof src[key] === 'object') {
                        handleJson(src[key])
                    }
                }
            }
        }
    },
    toCssLinearGradient: function (colors, direction) {
        if (!colors || !colors.length) {
            return null
        }
        return 'linear-gradient(' + (direction || 'to right') + ', ' + colors.join(', ') + ')'
    },
    applyBackgroundStyle: function (element, solidColor, gradientColors) {
        if (!element || !element.style) {
            return
        }
        const gradient = this.toCssLinearGradient(gradientColors)
        if (gradient) {
            element.style.backgroundImage = gradient
            element.style.backgroundColor = 'transparent'
            return
        }
        if (solidColor || solidColor === '') {
            element.style.backgroundColor = solidColor
        }
    },
    applyInputBorderStyle: function (element, borderColor, gradientColors, fillColor, borderWidth) {
        if (!element || !element.style) {
            return
        }
        const width = borderWidth || 1
        const gradient = this.toCssLinearGradient(gradientColors)
        if (gradient) {
            const fill = fillColor || '#fff'
            element.style.setProperty('border', width + 'px solid transparent', 'important')
            element.style.setProperty('background-color', 'transparent', 'important')
            element.style.setProperty(
                'background-image',
                'linear-gradient(' + fill + ', ' + fill + '), ' + gradient,
                'important',
            )
            element.style.setProperty('background-origin', 'border-box', 'important')
            element.style.setProperty('background-clip', 'padding-box, border-box', 'important')
            return
        }
        if (borderColor) {
            element.style.borderColor = borderColor
        }
        if (borderWidth) {
            element.style.borderWidth = width + 'px'
        }
    },
    getButtonBackgroundStyle: function (solidColor, gradientColors, backgroundImageUrl) {
        const style = {}
        if (backgroundImageUrl) {
            style.backgroundImage = 'url(' + backgroundImageUrl + ')'
            return style
        }
        const gradient = this.toCssLinearGradient(gradientColors)
        if (gradient) {
            style.backgroundImage = gradient
            style.backgroundColor = 'transparent'
            return style
        }
        if (solidColor || solidColor === '') {
            style.backgroundColor = solidColor
        }
        return style
    },
    refreshStyles: function (config, callback) {
        const self = this
        setTimeout(function () {
            const body = document.body
            const inputs = document.getElementsByClassName('v-input__slot')
            const textareas = document.getElementsByTagName('textarea')
            const photoButtons = document.getElementsByClassName('app-button-photo')
            const nextButtons = document.getElementsByClassName('app-button-next')
            const backButtons = document.getElementsByClassName('app-button-back')
            const links = document.getElementsByClassName('nav-link')

            if (!config) {
                if (body.style && window.screenBackgroundColor) {
                    body.style.backgroundColor = '#' + window.screenBackgroundColor
                }
                return true
            }

            if (body.style) {
                if (window.screenBackgroundColor) {
                    body.style.backgroundColor = '#' + window.screenBackgroundColor
                } else {
                    body.style.backgroundColor = config.backgroundColor
                }

                if (config.backgroundImage) {
                    body.style.backgroundImage = 'url(' + config.backgroundImage + ')'
                }

                if (config.scroll && body.classList) {
                    body.classList.add('body-scroll-active')
                }
            }
            if (inputs) {
                for (let i = 0; i < inputs.length; i++) {
                    self.applyInputBorderStyle(
                        inputs[i],
                        config.inputBorderColor,
                        config.inputBorderGradient,
                        config.inputBackgroundColor,
                        config.inputBorderWidth,
                    )
                }
                for (let i = 0; i < textareas.length; i++) {
                    self.applyInputBorderStyle(
                        textareas[i],
                        config.inputBorderColor,
                        config.inputBorderGradient,
                        config.inputBackgroundColor,
                        config.inputBorderWidth,
                    )
                }
            }
            if (nextButtons) {
                for (let i = 0; i < nextButtons.length; i++) {
                    if (nextButtons[i].style && config.buttons && config.buttons.next) {
                        nextButtons[i].style.color = config.buttons.next.textColor
                        self.applyBackgroundStyle(
                            nextButtons[i],
                            config.buttons.next.backgroundColor,
                            config.buttons.next.backgroundGradient,
                        )
                        if (config.buttons.next.borderRadius && config.buttons.next.borderRadius !== 0) {
                            nextButtons[i].classList.add('radius-inline')
                            nextButtons[i].style.borderRadius = config.buttons.next.borderRadius + 'px'
                        }
                        if (config.buttons.next.height) {
                            nextButtons[i].style.height = config.buttons.next.height
                        }
                    }
                }
            }
            if (backButtons) {
                for (let i = 0; i < backButtons.length; i++) {
                    if (backButtons[i].style && config.buttons && config.buttons.back) {
                        backButtons[i].style.color = config.buttons.back.textColor
                        self.applyBackgroundStyle(
                            backButtons[i],
                            config.buttons.back.backgroundColor,
                            config.buttons.back.backgroundGradient,
                        )
                        if (config.buttons.back.borderRadius && config.buttons.back.borderRadius !== 0) {
                            backButtons[i].classList.add('radius-inline')
                            backButtons[i].style.borderRadius = config.buttons.back.borderRadius + 'px'
                        }
                        if (config.buttons.back.height) {
                            backButtons[i].style.height = config.buttons.back.height
                        }
                    }
                }
            }
            if (photoButtons) {
                for (let i = 0; i < photoButtons.length; i++) {
                    if (photoButtons[i].style) {
                        photoButtons[i].style.borderColor = config.textColor
                        photoButtons[i].style.color = config.textColor
                    }
                }
            }
            if (links) {
                for (let i = 0; i < links.length; i++) {
                    if (links[i].style) {
                        links[i].style.color = config.textColor
                    }
                }
            }
            if (callback) {
                callback()
            }
        })
    },
    getYoutubeEmbedUrl: function (url) {
        url = url.trim()
        if (
            url.indexOf('/embed/') > -1 ||
            url.indexOf('.imagekit') > -1 ||
            url.indexOf('storageapi.mkgest') > -1 ||
            url.indexOf('.mkgest.') > -1 ||
            url.indexOf('amazonaws') > -1
        ) {
            return url
        }
        url = url.trim()
        let videoId = ''
        let splitId = url.split('v=')[1]
        if (splitId) {
            const ampersandPosition = splitId.indexOf('&')
            if (ampersandPosition !== -1) {
                videoId = splitId.substring(0, ampersandPosition)
            } else {
                videoId = splitId
            }
        } else {
            splitId = url.split('.be/')[1]
            if (splitId) {
                videoId = splitId
            }
        }
        if (url.indexOf('/shorts/') > -1) {
            videoId = url.split('/shorts/')[1]
        }
        if (url.indexOf('/live/') > -1) {
            videoId = url.split('/live/')[1]
        }
        return 'https://www.youtube.com/embed/' + videoId
    },
}
